/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // === WST Lightbox ===
(function() {
              // Overlay einmalig erstellen
              var overlay = document.createElement('div');
              overlay.className = 'wst-lightbox-overlay';
              overlay.innerHTML = '<button class="wst-lightbox-close" aria-label="Schließen">&times;</button><img src="" alt="">';
              document.body.appendChild(overlay);

              var overlayImg = overlay.querySelector('img');
              var closeBtn = overlay.querySelector('.wst-lightbox-close');

              function openLightbox(src, alt) {
                overlayImg.src = src;
                overlayImg.alt = alt || '';
                overlay.classList.add('is-open');
                document.body.style.overflow = 'hidden';
              }

              function closeLightbox() {
                overlay.classList.remove('is-open');
                document.body.style.overflow = '';
                overlayImg.src = '';
              }

              // Klick auf Trigger
              document.addEventListener('click', function(e) {
                var trigger = e.target.closest('[data-lightbox]');
                if (trigger) {
                  e.preventDefault();
                  openLightbox(trigger.href, trigger.querySelector('img') ? trigger.querySelector('img').alt : '');
                }
              });

              // Schließen
              closeBtn.addEventListener('click', closeLightbox);
              overlay.addEventListener('click', function(e) {
                if (e.target === overlay) closeLightbox();
              });
              document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape') closeLightbox();
              });
            })();





  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
